/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_UploadingInputs */

const en_directory_ai_tools_studio_photo_uploading = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading…`)
};

const zh_directory_ai_tools_studio_photo_uploading = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传中…`)
};

/**
* | output |
* | --- |
* | "Uploading…" |
*
* @param {Directory_Ai_Tools_Studio_Photo_UploadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_uploading = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_UploadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_UploadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_uploading(inputs)
	return zh_directory_ai_tools_studio_photo_uploading(inputs)
});
export { directory_ai_tools_studio_photo_uploading as "directory.ai_tools.studio.photo_uploading" }